export enum FinancialHealthIndicatorRouteParameters {
	mcag = 'mcag',
	indicatorCode = 'indicatorCode',
	indicator = 'indicator',
	indicatorGroups = 'indicatorGroups',
	localGovernment = 'localGovernment'
}
